module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0057.jpg?v=24b447f9";